import React from 'react';

const RedXMark = () => {
  return(
    <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1">
      <g id="Password-Validation" transform="translate(-1, -90)">
        <path d="M6.64301867,94.9998295 L10.866703,90.7756906 C11.0444323,90.5984159 11.0444323,90.3106853 10.866703,90.1329561 C10.6894283,89.9556813 10.4016977,89.9556813 10.2239685,90.1329561 L5.99982954,94.357095 L1.77569063,90.1329561 C1.59841589,89.9556813 1.31068535,89.9556813 1.13295606,90.1329561 C0.955681315,90.3106853 0.955681315,90.5984159 1.13295606,90.7756906 L5.35709497,94.9998295 L1.13295606,99.2239685 C0.955681315,99.4016977 0.955681315,99.6894283 1.13295606,99.866703 C1.22204798,99.955795 1.33841294,99.9998864 1.45432334,99.9998864 C1.5706883,99.9998864 1.68705326,99.955795 1.77569063,99.866703 L5.99982954,95.6425641 L10.2239685,99.866703 C10.3130604,99.955795 10.4294253,99.9998864 10.5453357,99.9998864 C10.6617007,99.9998864 10.7780657,99.955795 10.866703,99.866703 C11.0444323,99.6894283 11.0444323,99.4016977 10.866703,99.2239685 L6.64301867,94.9998295" fill="#F5F5F5"/>
      </g>
    </svg>
  )
};

export default RedXMark;
